import { Link } from "react-router-dom";
import { site } from "../lib/site";
import { openConsentBanner } from "../lib/consent";
import {
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconMail,
  IconPhone,
  IconPin,
} from "./Icon";
import { BrandMark } from "./BrandMark";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-900 text-brand-50 mt-20">
      <div className="container-page py-14 grid gap-10 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5">
            <BrandMark className="h-11 w-11 object-contain" />
            <div>
              <div className="font-display font-bold text-white text-lg">{site.name}</div>
              <div className="text-xs text-brand-200">Nettoyage professionnel · Vichy (03)</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-brand-100/90 leading-relaxed">
            Agent d'entretien à Vichy et en Allier. Bureaux, copropriétés, commerces, vitres et
            fin de chantier - devis gratuit sous 48 h.
          </p>
          <div className="mt-4 flex gap-2">
            <a
              href={site.social.facebook}
              className="h-11 w-11 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition-colors focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-900"
              aria-label="Facebook"
            >
              <IconFacebook className="h-5 w-5" />
            </a>
            <a
              href={site.social.instagram}
              className="h-11 w-11 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition-colors focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-900"
              aria-label="Instagram"
            >
              <IconInstagram className="h-5 w-5" />
            </a>
            <a
              href={site.social.linkedin}
              className="h-11 w-11 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition-colors focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-900"
              aria-label="LinkedIn"
            >
              <IconLinkedin className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-white text-sm font-semibold uppercase tracking-wider">Services</h3>
          <ul className="mt-4 space-y-2 text-sm text-brand-100/90">
            <li><Link to="/services#bureaux" className="hover:text-white">Nettoyage de bureaux</Link></li>
            <li><Link to="/services#coproprietes" className="hover:text-white">Nettoyage copropriétés</Link></li>
            <li><Link to="/services#commerces" className="hover:text-white">Nettoyage commerces</Link></li>
            <li><Link to="/nettoyage-airbnb" className="hover:text-white">Nettoyage Airbnb</Link></li>
            <li><Link to="/services#vitres" className="hover:text-white">Nettoyage de vitres</Link></li>
            <li><Link to="/services#chantier" className="hover:text-white">Nettoyage fin de chantier</Link></li>
            <li><Link to="/services#particuliers" className="hover:text-white">Entretien chez particuliers</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white text-sm font-semibold uppercase tracking-wider">Informations</h3>
          <ul className="mt-4 space-y-2 text-sm text-brand-100/90">
            <li><Link to="/a-propos" className="hover:text-white">À propos</Link></li>
            <li><Link to="/zones-intervention" className="hover:text-white">Zones d'intervention</Link></li>
            <li><Link to="/contact" className="hover:text-white">Devis gratuit</Link></li>
            <li><Link to="/politique-de-confidentialite" className="hover:text-white">Politique de confidentialité</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link></li>
            <li>
              <button
                type="button"
                onClick={openConsentBanner}
                className="hover:text-white text-left"
              >
                Gérer mes cookies
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white text-sm font-semibold uppercase tracking-wider">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-brand-100/90">
            <li className="flex items-start gap-2">
              <IconPin className="h-4 w-4 mt-0.5 text-brand-300" />
              <span>
                {site.address.postalCode} {site.address.city}
              </span>
            </li>
            <li className="flex items-center gap-2">
              <IconPhone className="h-4 w-4 text-brand-300" />
              <a href={site.phoneHref} className="hover:text-white">{site.phoneDisplay}</a>
            </li>
            <li className="flex items-center gap-2">
              <IconMail className="h-4 w-4 text-brand-300" />
              <a href={site.emailHref} className="hover:text-white">{site.email}</a>
            </li>
            <li className="text-xs text-brand-200/80 mt-3">{site.hours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-page py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-200">
          <div>© {year} {site.legalName}. Tous droits réservés.</div>
          <div className="flex flex-wrap gap-4">
            <Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link>
            <Link to="/politique-de-confidentialite" className="hover:text-white">Confidentialité</Link>
            <button
              type="button"
              onClick={openConsentBanner}
              className="hover:text-white"
            >
              Gérer mes cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
